var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('Building',{on:{"action-executed":_vm.handleControlAction,"color-selected":_vm.handleControlColorSelected,"control-moved":_vm.handleControlMoved,"indicator-deactivated":_vm.handleIndicatorDeactivated}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }